import { useTranslation } from "next-i18next"
import parse from "html-react-parser"

const useLeadGeneration = authorData => {
  const { t } = useTranslation()
  const i18n = {
    mainTitle: "Need Shopping help?",
    enquiryForm: authorData?.formTitle
      ? parse(authorData?.formTitle.replaceAll("&amp;nbsp;", " "))
      : t("kf.productEnquiry.main.enquiryTitle"),
    requiredInfoText: authorData?.formDescription
      ? parse(authorData?.formDescription.replaceAll("&amp;nbsp;", " "))
      : t("kf.leadGeneration.description"),

    mobileNumber: "Phone Number*",
    name: t("kf.pdp.label.username"),
    nameError: "Your Name is required",
    privacyText: authorData?.leadGenerationPrivacyPolicyText
      ? authorData?.leadGenerationPrivacyPolicyText
      : t("kf.leadGeneration.privacyText"),
    submit: "Submit",
    cancel: t("kf.customerSupport.label.cancel"),
    messageDescriptionSuccess: t("kf.leadGeneration.messageDescriptionSuccess", "Thanks for providing your details. One of our expert will contact you shortly."),
    backToForm: t("kf.leadGeneration.backToForm", "Close"),
    errorMobileNumber: "Please enter a valid number",
    validEmailId: t("kf.contactus.error.validEmail"),
    email: t("kf.registration.label.email"),
    phoneNumber: t("kf.pdp.label.phoneNumber"),
    city: t("kf.dealershipEnquiry.city"),
    state: t("kf.account.label.state"),
    scheduleAVisit: t("kf.leadGeneration.scheduleAVisit"),
    validCity: t("kf.account.error.cityError"),
    createDesignPlan: t("kf.kec.label.createDesignPlan"),
    chooseAppointments: t("kf.kec.label.chooseAppointments"),
    bookAppointment: t("kf.kec.button.label"),
    heading1: t("kf.kec.heading1.label"),
    heading2: t("kf.kec.heading2.label"),
    requiredFields: t("kf.dealershipEnquiry.dealershipFormDescription"),
  }

  return i18n
}

export default useLeadGeneration
